{
  "tabs": {
    "chat": "Keskustelu",
    "reminders": "Muistutukset",
    "calendar": "Kalenteri",
    "settings": "Asetukset"
  },
  "common": {
    "cancel": "Peruuta",
    "save": "Tallenna",
    "confirm": "Vahvista",
    "delete": "Poista",
    "back": "Takaisin",
    "close": "Sulje",
    "edit": "Muokkaa",
    "search": "Haku",
    "all": "Kaikki",
    "loading": "Ladataan...",
    "error": "Jokin meni pieleen",
    "notFound": "Ei löytynyt",
    "tryAgain": "Yritä uudelleen",
    "retry": "Yritä uudelleen",
    "undo": "Kumoa",
    "pullToRefresh": "Vedä päivittääksesi",
    "justNow": "juuri nyt"
  },
  "auth": {
    "welcome": "Tervetuloa FishMemoryyn",
    "tagline": "WhatsApp-muistutusavustajasi, nyt taskussasi.",
    "subtitle": "WhatsApp-muistutusavustajasi, nyt taskussasi.",
    "phoneLabel": "WhatsApp-numerosi",
    "phoneHint": "Lähetämme vahvistuskoodin WhatsAppilla",
    "invalidPhone": "Anna kelvollinen puhelinnumero",
    "continue": "Jatka",
    "enterPhone": "Syötä WhatsApp-numerosi",
    "phonePlaceholder": "Puhelinnumero",
    "sendCode": "Lähetä koodi",
    "verifyTitle": "Vahvista numerosi",
    "otpSentTo": "6-numeroinen koodi lähetetty numeroon {{phone}} WhatsAppilla",
    "enterFullCode": "Syötä kaikki 6 numeroa",
    "invalidOtp": "Virheellinen koodi. Yritä uudelleen.",
    "otpFailed": "Koodin lähetys epäonnistui. Yritä uudelleen.",
    "otpResent": "Koodi lähetetty uudelleen",
    "resendIn": "Lähetä uudelleen {{seconds}}s kuluttua",
    "resendCode": "Lähetä koodi uudelleen",
    "enterOtp": "Syötä WhatsAppiin lähetetty koodi",
    "verify": "Vahvista",
    "resend": "Lähetä koodi uudelleen",
    "wrongNumber": "Väärä numero?",
    "backToPhone": "Takaisin numeroon",
    "editPhone": "Muokkaa numeroa",
    "error": "Virhe",
    "setupTitle": "Aloitetaan asetus",
    "setupSubtitle": "Voit muuttaa näitä myöhemmin Asetuksissa",
    "namePlaceholder": "Nimesi",
    "letsGo": "Valmis",
    "skipForNow": "Ohita nyt"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Kirjoita viesti...",
    "inputPlaceholder": "Kirjoita viesti...",
    "typing": "FishMemory kirjoittaa...",
    "online": "Online",
    "connecting": "Yhdistetään...",
    "reconnecting": "Yhdistetään uudelleen...",
    "offline": "Offline",
    "empty": "Aloita keskustelu",
    "emptyHint": "Luo muistutuksia, tarkista aikataulusi tai kysy apua.",
    "emptyAction": "Lähetä esimerkkimuistutus",
    "actions": "Keskustelutoiminnot",
    "keep": "Säilytä viestit",
    "clearTitle": "Tyhjennä keskustelu",
    "clearConfirm": "Poistetaanko kaikki viestit tältä laitteelta? Tätä ei voi perua.",
    "clear": "Tyhjennä keskustelu",
    "optionSelected": "Valittu: {{label}}",
    "sendingSelection": "Lähetetään...",
    "connectionLost": "Yhdistetään uudelleen..."
  },
  "reminders": {
    "title": "Muistutukseni",
    "active": "Aktiiviset",
    "today": "Tänään",
    "thisWeek": "Tällä viikolla",
    "history": "Historia",
    "items": "kohdetta",
    "emptyTitle": "Ei vielä muistutuksia",
    "emptySubtitle": "Luo muistutus keskustelussa, niin se näkyy täällä.",
    "emptyAction": "Avaa keskustelu",
    "filterActive": "Aktiiviset",
    "filterToday": "Tänään",
    "filterWeek": "Tällä viikolla",
    "filterHistory": "Historia",
    "emptyState": "Ei vielä muistutuksia. Aloita keskustelu!",
    "swipeDone": "Tehty",
    "swipeSnooze": "Torkku",
    "swipeDelete": "Poista",
    "search": "Hae muistutuksia...",
    "upcoming": "Tulossa",
    "completed": "Valmiit",
    "overdue": "Myöhässä",
    "tomorrow": "Huomenna",
    "synced": "Synkronoitu {{value}}",
    "swipeHint": "Pyyhkäise muistutusta saadaksesi lisää toimintoja",
    "noResults": "Ei muistutuksia haullesi",
    "noResultsHint": "Kokeile eri hakusanaa tai tyhjennä haku",
    "deleteAllFailed": "Kaikkien muistutusten poistaminen epäonnistui"
  },
  "calendar": {
    "title": "Kalenteri",
    "today": "Tänään",
    "tomorrow": "Huomenna",
    "completed": "tehty",
    "noEvents": "Ei tapahtumia",
    "noEventsSubtitle": "Valitse päivämäärä nähdäksesi muistutukset ja kalenteritapahtumat.",
    "googleEvent": "Google Kalenteri",
    "legendActive": "Aktiiviset",
    "legendRecurring": "Toistuvat",
    "legendDone": "Tehdyt",
    "legendGoogle": "Google",
    "previousMonth": "Edellinen kuukausi",
    "nextMonth": "Seuraava kuukausi",
    "previousYear": "Edellinen vuosi",
    "nextYear": "Seuraava vuosi",
    "goToToday": "Siirry tänään",
    "all": "Kaikki",
    "active": "Aktiiviset",
    "done": "Tehdyt",
    "paused": "Tauolla"
  },
  "settings": {
    "title": "Asetukset",
    "profile": "Profiili",
    "name": "Näyttönimi",
    "enterName": "Syötä nimesi",
    "language": "Kieli",
    "uiLanguage": "Sovelluksen kieli",
    "uiLanguageHelp": "Muuttaa sovelluksen käyttöliittymän, kalenterin otsikot ja asettelun suunnan vain tällä laitteella.",
    "serverLanguage": "Keskustelun kieli",
    "serverLanguageHelp": "Muuttaa palvelimen vastausten ja muistutusviestien kielen tilillesi.",
    "timezone": "Aikavyöhyke",
    "currentTimezone": "Nykyinen aikavyöhyke",
    "timezoneHelp": "Kaikki muistutusten ajat näytetään tämän aikavyöhykkeen mukaan.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Tallenna aikavyöhyke",
    "timezoneSaved": "Aikavyöhyke päivitetty",
    "detect": "Tunnista",
    "detectFailed": "Aikavyöhykettä ei voitu tunnistaa",
    "autoDetect": "Tunnista automaattisesti GPS:stä",
    "notifications": "Ilmoitukset",
    "notificationsHelp": "Seuranta-muistutukset hallitsevat toistuvia hälytyksiä muistutuksen jälkeen. Laitetason ilmoitusluvat hallitaan puhelimen asetuksissa.",
    "pushEnabled": "Push-ilmoitukset",
    "autoDoneOnFire": "Merkitse automaattisesti tehdyksi",
    "autoDoneOnFireDesc": "Pois päältä ollessa muistutukset pysyvät aktiivisina, kunnes merkitset ne tehdyiksi.",
    "googleCalendar": "Google Kalenteri",
    "google": "Google Kalenteri",
    "googleConnected": "Yhdistetty",
    "googleDisconnected": "Ei yhdistetty",
    "googleConnectedHelp": "Uudet muistutukset voidaan synkronoida kalenteriisi automaattisesti.",
    "googleDisconnectedHelp": "Yhdistä Google Kalenteri pitääksesi muistutukset ja tapahtumat synkronoituna.",
    "googleConnectFailed": "Google Kalenterin yhdistäminen epäonnistui",
    "connected": "Yhdistetty",
    "disconnected": "Ei yhdistetty",
    "connect": "Yhdistä",
    "disconnect": "Katkaise yhteys",
    "autoSync": "Synkronoi uudet muistutukset automaattisesti",
    "autosync": "Synkronoi uudet muistutukset automaattisesti",
    "subscription": "Tilaus",
    "trialUsed": "Koeaika: {{used}}/{{total}} käytetty",
    "trialStatus": "Koeaika käytettävissä",
    "activeStatus": "Aktiivinen tilaus",
    "expiredStatus": "Tilaus vanhentunut",
    "unsubscribedStatus": "Ei tilausta",
    "about": "Tietoja",
    "version": "Versio",
    "logout": "Kirjaudu ulos",
    "logoutTitle": "Kirjaudu ulos",
    "logoutConfirm": "Haluatko varmasti kirjautua ulos?",
    "noName": "Nimeä ei asetettu",
    "serverConnection": "Palvelinyhteys",
    "serverUrl": "Palvelimen URL",
    "serverEdit": "Muokkaa",
    "saveReconnect": "Tallenna ja yhdistä uudelleen",
    "resetDefault": "Palauta oletus",
    "invalidServerUrlTitle": "Virheellinen palvelimen URL",
    "invalidServerUrlMessage": "Anna kelvollinen http- tai https-palvelimen URL, esim. https://example.com",
    "uiLanguageChangeFailed": "Sovelluksen kielen vaihtaminen epäonnistui. Yritä uudelleen.",
    "serverLanguageChangeFailed": "Keskustelukielen vaihtaminen epäonnistui. Yritä uudelleen.",
    "timezoneChangeFailed": "Aikavyöhykkeen vaihtaminen epäonnistui. Yritä uudelleen.",
    "autoSyncChangeFailed": "Automaattisen synkronoinnin päivitys epäonnistui. Yritä uudelleen.",
    "nameChangeFailed": "Näyttönimen päivitys epäonnistui. Yritä uudelleen.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Muistutuksen tiedot",
    "editTime": "Muokkaa aikaa",
    "rename": "Nimeä uudelleen",
    "snooze": "Torkku",
    "snooze15": "Torkku 15 minuuttia",
    "pause": "Tauko",
    "pauseReminder": "Keskeytä muistutus",
    "resume": "Jatka",
    "resumeReminder": "Jatka muistutusta",
    "skip": "Ohita seuraava",
    "skipOccurrence": "Ohita tämä kerta",
    "syncGoogle": "Synkronoi Googleen",
    "delete": "Poista",
    "deleteTitle": "Poista muistutus",
    "deleteConfirm": "Tämä muistutus poistetaan pysyvästi.",
    "deleteRecurringTitle": "Poista toistuva muistutus",
    "deleteRecurringMessage": "Haluatko ohittaa tämän kerran vai poistaa koko sarjan?",
    "deleteThisOccurrence": "Ohita tämä kerta",
    "deleteEntireSeries": "Poista koko sarja",
    "done": "Tehty",
    "markDone": "Merkitse tehdyksi",
    "undo": "Palauta",
    "undoPrompt": "Tarvitsetko sen aktiiviseksi uudelleen? Palauta nyt.",
    "recurring": "Toistuva",
    "nextRun": "Seuraava kerta",
    "oneTime": "Kerran",
    "pending": "Odottaa",
    "sent": "Lähetetty",
    "paused": "Keskeytetty",
    "active": "Aktiivinen",
    "snoozed": "Torkutettu",
    "localTime": "Näytetään paikallisessa ajassa",
    "recurrence": "Toistuvuus",
    "created": "Luotu",
    "tags": "Tunnisteet",
    "fireCount": "Kerrat muistutettu",
    "actions": "Toiminnot",
    "none": "Ei mitään",
    "snoozeFailed": "Muistutuksen torkutus epäonnistui",
    "pauseFailed": "Muistutuksen keskeytys epäonnistui",
    "resumeFailed": "Muistutuksen jatkaminen epäonnistui",
    "skipFailed": "Muistutuksen ohitus epäonnistui",
    "doneFailed": "Muistutuksen merkitseminen tehdyksi epäonnistui",
    "undoFailed": "Muistutuksen tilan palautus epäonnistui",
    "deleteFailed": "Muistutuksen poistaminen epäonnistui",
    "rescheduleTitle": "Uudelleen ajoitus?",
    "rescheduleMsg": "Tämä muistutus on myöhässä. Haluatko ajoittaa sen uudelleen?",
    "reschedule15": "15 minuutin päästä",
    "reschedule60": "1 tunnin päästä",
    "keepOverdue": "Pidä nykyisenä"
  },
  "onboarding": {
    "slide1Title": "Tervetuloa FishMemoryyn",
    "slide1Sub": "Henkilökohtainen muistutusavustajasi — WhatsAppin voimin ja taskuusi rakennettu.",
    "slide2Title": "Keskustele luonnollisesti",
    "slide2Sub": "Kirjoita muistutukset kuten ajattelet: \"Muistuta soittamaan äidille huomenna klo 15\" — me hoidamme loput.",
    "slide3Title": "Älä koskaan unohda mitään",
    "slide3Sub": "Saat ajantasaiset ilmoitukset, järjestä tunnisteilla ja pysy kaiken tärkeän päällä.",
    "getStarted": "Aloita",
    "next": "Seuraava",
    "firstReminderTitle": "Luo ensimmäinen muistutuksesi!",
    "firstReminderHint": "Kokeile kirjoittaa esimerkiksi:",
    "firstReminderExample": "Muistuta juomaan vettä huomenna klo 9",
    "gotIt": "Ymmärretty!",
    "notifRationaleTitle": "Pysy ajassa",
    "notifRationaleBody": "FishMemory tarvitsee ilmoituksia muistuttaakseen sinua ajoissa. Saat hälytyksiä vain luomistasi muistutuksista.",
    "notifRationaleAllow": "Salli ilmoitukset",
    "notifRationaleLater": "Ehkä myöhemmin",
    "swipeHint": "Pyyhkäise oikealle pikatoimintoihin →",
    "calendarDragHint": "Raahaa laajentaaksesi ↕"
  }
}
